import React from 'react';
import { useDispatch, useSelector } from 'react-redux'
import Aux from '../../hoc/Aux';
import { useForm, Controller } from 'react-hook-form'
import * as actions from '../../store/actions/index';
import Select from 'react-select'
import Navigation from './Navigation';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import { useParams } from "react-router";
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';

const projectCustomer = (props) => {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const alert = useAlert();
  const ct = useCustomTranslation();
  let { projectId } = useParams();

  const loading = useSelector(state => state.inventory.loading_project );

  const { register, handleSubmit, control, getValues } = useForm();


  const onSubmit = data => {
    data = {...data,
      id: projectId,
      customer_countrycode: Object(data.customer_countrycode).code}
    dispatch( actions.updateProject(data) ).then( (res) => {
      alert.show('Daten wurden gespeichert', {type: "success"});
     });
  };

  const thisProject = useSelector(state => {
    return (projectId) => actions.getProject(state, projectId)
  });

  let project = thisProject(projectId) || {};

  const intialValues = {
    customer_name: project["customer_name"],
    customer_company: project["customer_company"],
    customer_phone: project["customer_phone"],
    customer_email: project["customer_email"],
    customer_street: project["customer_street"],
    customer_housenumber: project["customer_housenumber"],
    customer_zipcode: project["customer_zipcode"],
    customer_city: project["customer_city"],
    customer_district: project["customer_district"],
    customer_countrycode: (project["customer_countrycode"])? project["customer_countrycode"].toLowerCase() : 'de',
  };

  const countryOptions = () => actions.availableCountries.map( x => { return { code: x.toLowerCase(), label:  t('countryname_' + x) }} )

  if ( !loading || project !== {}) {
    project = thisProject(projectId) || {};

    return (

    <Aux>
    	<div className="main-container">
    		<div className="container">
    			<div className="row justify-content-center mt-5">
           <div className="col-xl-11 col-lg-11">
    					<div className="page-header">
              <h1 style={{fontSize: "1.0rem"}}>
                <span id="backlink"><Link to={ROUTES.TO_PROJECTS}>{ ct('project.navi.link.my_projects') }</Link></span> <i className="material-icons" style={{margin: "-5px", verticalAlign: "middle"}}>keyboard_arrow_right</i> {project.title}
              </h1>
    						<span className="lead"></span>
    					</div>
    				</div>
    			</div>
    			<div className="row justify-content-center mt-3">
            <div className="col-xl-3 col-lg-3 mb-10">
              <Navigation activeItem="project_customer_data" projectId={projectId} />
    				</div>

    				<div className="col-xl-8 col-lg-8 mb-10">
    					<div className="card">
    						<div className="card-body">
    							<div className="tab-content">
    								<div className="tab-pane fade show active" role="tabpanel" id="userdata">
    									<h4>{ ct('account.navigation.to_customer') }</h4>
    									<form onSubmit={handleSubmit(onSubmit)}>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.customer_name.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="customer_name"
                              defaultValue={intialValues.customer_name}
                              ref={register({ required: true, maxLength: 20 })} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.customer_company.label') }</label>
    											<div className="col">
    												<input
                              className="form-control"
                              name="customer_company"
                              defaultValue={intialValues.customer_company}
                              ref={register()} />
                          </div>
    										</div>
                        <div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.customer_phone.label') }</label>
    											<div className="col">
    												<input
                              className="form-control"
                              name="customer_phone"
                              defaultValue={intialValues.customer_phone}
                              ref={register()} />
                          </div>
    										</div>
                        <div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.customer_email.label') }</label>
    											<div className="col">
    												<input
                              className="form-control"
                              name="customer_email"
                              defaultValue={intialValues.customer_email}
                              ref={register()} />
                          </div>
    										</div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.customer_street.label') }</label>
    											<div className="col">
                            <input
                              className="form-control"
                              name="customer_street"
                              defaultValue={intialValues.customer_street}
                              ref={register()} />
                          </div>
                          <div className="col-2">
                            <input
                              className="form-control"
                              name="customer_housenumber"
                              defaultValue={intialValues.customer_housenumber}
                              ref={register()} />
                          </div>
                        </div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.customer_zipcode.label') }</label>
    											<div className="col-2">
                            <input
                              className="form-control"
                              name="customer_zipcode"
                              defaultValue={intialValues.customer_zipcode}
                              ref={register()} />
                          </div>
    											<div className="col">
                            <input
                              className="form-control"
                              name="customer_city"
                              defaultValue={intialValues.customer_city}
                              ref={register()} />
                          </div>
    										</div>
                        <div className="form-group row align-items-center">
                          <label className="col-3">{ t( 'form.project.customer_district.label') }</label>
                          <div className="col">
                            <input
                              className="form-control"
                              name="customer_district"
                              defaultValue={intialValues.customer_district}
                              ref={register()} />
                          </div>
                        </div>
    										<div className="form-group row align-items-center">
    											<label className="col-3">{ t( 'form.project.country.label') }</label>
    											<div className="col">
                            <Controller
                                as={Select}
                                placeholder={ ct('userprofile.form.country.placeholder') }
                                defaultValue={countryOptions().find(o => o.code === intialValues.customer_countrycode)}
                                options={countryOptions()}
                                getOptionLabel={option => option.label}
                                getOptionValue={option => option.code}
                                value={countryOptions().find(o => o.code === getValues("country"))}
                                onChange={([option]) => option.code}
                                name="customer_countrycode"
                                register={register}
                                rules={{ required: false }}
                                control={control}
                                styles={{
                                  control: (provided, { isFocused }) => ({
                                      ...provided,
                                      boxShadow: "0",
                                      fontSize: ".875rem",
                                      border: isFocused ? "1px solid #99CAFE" : "1px solid #dee2e6",
                                      ':hover': { border: "1px solid #dee2e6" }})
                                  }}
                              />
    											</div>
    										</div>




    										<div className="row justify-content-end">
    											<button type="submit" className="btn btn-primary btn-project">{ ct('userprofile.form.button.submit') }</button>
    										</div>
    									</form>
    								</div>
    							</div>
    						</div>
    					</div>
    				</div>
    			</div>
    		</div>
    	</div>
    </Aux>
  )
} else {
 return null;
}


};

export default projectCustomer;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectCustomer.js